import { Directive, HostListener, ElementRef, Renderer2, Input, Output, EventEmitter } from '@angular/core';

@Directive({
    selector: '[shadowHeader]'
})
export class ShadowHeaderDirective {
    constructor(private elementRef: ElementRef, private renderer: Renderer2) {

    }
    @HostListener('window:scroll', ['$event']) onScrollEvent(event: Event) {
        if (window.pageYOffset > 0) {
            this.renderer.addClass(this.elementRef.nativeElement,"shadow-sm");
        }
        else {
            this.renderer.removeClass(this.elementRef.nativeElement,"shadow-sm");
        }
    }
}
